export const MAIN_SIDE_PANEL = "MAIN_SIDE_PANEL";
export const MENU_PANEL = "MENU_PANEL";
export const FLIP_PANEL = "FLIP_PANEL";
export const ERROR_MODAL = "ERROR_MODAL";
export const IMAGE_MODAL = "IMAGE_MODAL";